module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.6145/images/default-company-avatar.png"